module.exports = {
	"pagination": {
		"DescribeTrails": {
			"result_key": "trailList"
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/aws-sdk/apis/cloudtrail-2013-11-01.paginators.json
 ** module id = 1270
 ** module chunks = 0
 **/